/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { SxProps } from '@mui/material/styles';

export const addressCardHeaderSX: SxProps = {
	minWidth: '230px',
	// extra space for check icon
};
